module.exports = __webpack_public_path__ + "img/4.cd51076e.png";